import Quill from "quill";

export default class ImageFormatModule {
  constructor(quill, options = {}) {
    this.quill = quill;
    this.options = options;
    this.toolbar = null;
    this.currentImage = null;

    this.handleClickBound = this.handleClick.bind(this);
    this.handleMutationsBound = this.handleMutations.bind(this);

    this.quill.root.addEventListener("click", this.handleClickBound);
    document.addEventListener("click", this.handleClickBound, true);

    this.observer = new MutationObserver(this.handleMutationsBound);
    this.observer.observe(this.quill.root, {
      childList: true,
      subtree: true,
    });
  }

  handleClick(evt) {
    const target = evt.target;
    const clickedInsideEditor = this.quill.root.contains(target);
    const clickedInsideToolbar = this.toolbar?.contains(target);

    // Check if editor is in read-only/preview mode
    // Quill disables the editor when readOnly is true, so isEnabled() returns false
    const isReadOnly = !this.quill.isEnabled() || this.quill.root.getAttribute('contenteditable') === 'false';

    if (clickedInsideEditor && target.tagName === "IMG") {
      // Only show toolbar if editor is not in read-only mode
      if (!isReadOnly) {
        this.showToolbar(target);
      } else {
        // If in read-only mode, ensure toolbar is removed
        this.removeToolbar();
      }
      return;
    }

    if (!clickedInsideEditor && !clickedInsideToolbar) {
      this.removeToolbar();
    }
  }

  handleMutations() {
    if (this.currentImage && !this.quill.root.contains(this.currentImage)) {
      this.removeToolbar();
      return;
    }

    // Check if editor became read-only while toolbar is open
    if (this.toolbar && this.currentImage) {
      const isReadOnly = !this.quill.isEnabled() || this.quill.root.getAttribute('contenteditable') === 'false';
      if (isReadOnly) {
        this.removeToolbar();
      }
    }
  }

  showToolbar(img) {
    this.removeToolbar();
    this.currentImage = img;

    const toolbar = document.createElement("div");
    toolbar.style.position = "absolute";
    toolbar.style.background = "#fff";
    toolbar.style.border = "1px solid #EA655B";
    toolbar.style.borderRadius = "4px";
    toolbar.style.padding = "4px";
    toolbar.style.display = "flex";
    toolbar.style.gap = "4px";
    toolbar.style.zIndex = "1000";

    // Buttons
    const alignLeft = this.createButton("Left", () => {
      img.style.float = "left";
      img.style.display = "";
      img.style.margin = "0 10px 10px 0";
    });

    const alignCenter = this.createButton("Center", () => {
      img.style.float = "none";
      img.style.display = "block";
      img.style.margin = "0 auto 10px auto";
    });

    const alignRight = this.createButton("Right", () => {
      img.style.float = "right";
      img.style.display = "";
      img.style.margin = "0 0 10px 10px";
    });

    // Resize Slider
    const editorDiv = document.querySelector(".ql-editor");
    const editorWidth = editorDiv?.getBoundingClientRect().width || 600;

    const resizeInput = document.createElement("input");
    resizeInput.type = "range";
    resizeInput.min = 50;
    resizeInput.max = editorWidth;
    resizeInput.value = img.getBoundingClientRect().width;
    resizeInput.style.width = "100px";
    resizeInput.style.accentColor = "#EA655B";

    resizeInput.addEventListener("input", () => {
      img.style.width = `${resizeInput.value}px`;
    });

    toolbar.append(alignLeft, alignCenter, alignRight, resizeInput);
    document.body.appendChild(toolbar);

    const updatePosition = () => {
      const rect = img.getBoundingClientRect();
      toolbar.style.top = `${window.scrollY + rect.top - toolbar.offsetHeight - 5}px`;
      toolbar.style.left = `${window.scrollX + rect.left}px`;
    };

    updatePosition();
    window.addEventListener("scroll", updatePosition);
    window.addEventListener("resize", updatePosition);

    this.removeToolbar = () => {
      window.removeEventListener("scroll", updatePosition);
      window.removeEventListener("resize", updatePosition);
      if (toolbar.parentNode) toolbar.parentNode.removeChild(toolbar);
      this.toolbar = null;
      this.currentImage = null;
    };

    this.toolbar = toolbar;
  }

  createButton(label, onClick) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.innerText = label;
    btn.onclick = () => {
      onClick();
      this.removeToolbar();
    };
    btn.style.padding = "2px 6px";
    btn.style.cursor = "pointer";
    btn.className = "theme-btn noBg";
    btn.style.border = "1px solid #EA655B";
    btn.style.background = 'transparent';
    btn.style.color = "#EA655B";
    return btn;
  }

  removeToolbar() {
    if (this.toolbar && this.toolbar.parentNode) {
      this.toolbar.parentNode.removeChild(this.toolbar);
    }
    this.toolbar = null;
    this.currentImage = null;
  }
}
